import { createSelector } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { RootState } from '~/store'
import { type TaskObject } from '~/types/TaskType'
import { useConversationUuid } from '../conversation/useConversationUuid'

export function useTaskObj(uuid: string | null = null) {
  const currentUuid = useConversationUuid(uuid || undefined)
  const uuidToUse = uuid || currentUuid

  const selectTaskObj = (uuid: string) => {
    return createSelector(
      [(state: RootState) => state.chat.task_objs],
      (task_objs): TaskObject | null => {
        const taskObj = task_objs[uuid]
        if (taskObj == null) {
          return null
        }
        return taskObj
      }
    )
  }

  return useSelector(selectTaskObj(uuidToUse))
}
